"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogout = void 0;
var _react = require("react");
var _utils = require("../../utils");
var _UserAnalytics = require("./UserAnalytics");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useLogout = function useLogout(_ref) {
  var _ref$onLogout = _ref.onLogout,
    onLogout = _ref$onLogout === void 0 ? _utils.noop : _ref$onLogout,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _utils.noop : _ref$onError;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loadingSignOut = _useState2[0],
    setLoadingSignOut = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    performLogout = _useState4[0],
    setPerformLogout = _useState4[1];
  (0, _react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var auth0LogoutUrl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoadingSignOut(true);
                _context.next = 4;
                return _utils.apiWithoutErrorsHandler.post((0, _utils.getSignOutUrl)(), {});
              case 4:
                (0, _UserAnalytics.trackUserEvent)({
                  eventName: 'Log out'
                });
                (0, _UserAnalytics.forgetUser)();
                onLogout();
                _context.next = 14;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                auth0LogoutUrl = "https://".concat(process.env.REACT_APP_AUTH0_DOMAIN, "/v2/logout");
                window.location.href = auth0LogoutUrl;
                onError();
              case 14:
                _context.prev = 14;
                setLoadingSignOut(false);
                return _context.finish(14);
              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9, 14, 17]]);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (performLogout) {
      setPerformLogout(false);
      fetchData();
    }
  }, [onLogout, onError, performLogout]);
  return {
    signOut: function signOut() {
      return setPerformLogout(true);
    },
    loadingSignOut: loadingSignOut
  };
};
exports.useLogout = useLogout;